import {TranslationKey} from '@enums'
import {Grid} from '@mui/material'

import React from 'react'

import {renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {useCreditDecisionFormModel} from './credit-decision-form-model'

/**
 * Credit Decision Form page
 */
export function CreditDecisionFormPage() {
  const {onDiscard, onSubmit, t, creditDecisionFormFields} = useCreditDecisionFormModel()

  return (
    <>
      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {creditDecisionFormFields.map((item, index) => (
            <Grid sm={4} item key={`credit-decision-form-field-${index}`}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <ComposedComponents.FormButtons
        leftButton={{label: t(TranslationKey.Discard), onClick: onDiscard}}
        rightButton={{label: t(TranslationKey.Save), onClick: onSubmit}}
      />
    </>
  )
}
